import CommentIcon from '@atlaskit/icon/core/comment';
import * as React from 'react';

export function SvgComment() {
  return <CommentIcon label="" testId="ads-refreshed-icon" />;
}
